import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-554cf5d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.kilimall.com/kenya/new_wap/download/ic_kilimall_logo.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.kilimall.com/kenya/new_wap/download/kilimall_download_qrcode.png",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Download")

import { PropType, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'downloadApp',
  props: {
  modelValue: {
    type: Object as PropType<boolean>,
    required: true,
  },
  title: {
    type: Object as PropType<String>,
    default: 'Download APP for more service'
  },
  content: {
    type: Object as PropType<String>,
    default: 'Please install our APP in google play store(IOS not supported) or scan code to download'
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props


watch(() => props.modelValue, (state) => {
  isShowDownload.value = props.modelValue
})
 
let isShowDownload = ref(props.modelValue)
const title = props.title
const content = props.content
let u = navigator.userAgent;
let isAndroid = ref(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) 

const onClickHide = () => {
  
  isShowDownload.value = false
  emit("update:modelValue", false)
}
const download_fn = () => {
    window.location.href = 'https://play.google.com/store/apps/details?id=net.kilimall.shop'
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createBlock(_component_van_overlay, {
    show: _unref(isShowDownload),
    onClick: onClickHide,
    "z-index": "100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("view", _hoisted_1, [
        _createElementVNode("div", {
          class: "block",
          style: _normalizeStyle([_unref(isAndroid) ? 'height:60%': 'height:55%'])
        }, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_unref(title)), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(content)), 1)
          ]),
          _hoisted_3,
          (_unref(isAndroid))
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                round: "",
                style: {"width":"60%","fontWeight":"700"},
                icon: "down",
                type: "info",
                color: "#F87622",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (download_fn()), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})